import { render, staticRenderFns } from "./front.vue?vue&type=template&id=96be2f30&scoped=true"
import script from "./front.vue?vue&type=script&lang=js"
export * from "./front.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96be2f30",
  null
  
)

export default component.exports